/* @flow */
import { InfoIcon } from '@/assets/icons'
import React from 'react'
class InfoToast extends React.PureComponent {
  handleClick() {
    const { onMessageClick } = this.props
    if (onMessageClick) {
      onMessageClick(import.meta.env.VITE_FRONT_URL)
    }
  }

  render() {
    const { title, body, iconColor="var(--color-brand-04)" } = this.props
    return (
      <div className="message" onClick={this.handleClick.bind(this)}>
        <InfoIcon width="48px" fillcolor={iconColor}/>

        <div className="message__text">
          <div className="message__main-text">{title}</div>
          <div className="message__sub-text">{body}</div>
        </div>
      </div>
    )
  }
}

export default InfoToast
